import React from 'react';
import { Pagination, Dropdown, Tooltip, OverlayTrigger } from 'react-bootstrap';

const CustomPaginationComponent = ({
  current,
  pageSize,
  onChange,
  onShowSizeChange,
  pageSizeOptions
}) => {

  const handlePageChange = (page) => {
      onChange(page);
  };

  const handlePageSizeChange = (size) => {
    onShowSizeChange(size); 
  };
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div className="mr-2">
      <Pagination
        className="mb-0"
      >
        <OverlayTrigger overlay={<Tooltip>Previous</Tooltip>}>
          <Pagination.Prev
            onClick={() => handlePageChange(current - 1)}          
          />
        </OverlayTrigger>

        <OverlayTrigger overlay={<Tooltip>Next</Tooltip>}>
          <Pagination.Next
            onClick={() => handlePageChange(current + 1)}
          />
        </OverlayTrigger>
      </Pagination>
      </div>
      <div className="mr-2">
        <span>
         Page {current + 1}
        </span>
      </div>
      <div>
        <Dropdown>
          <Dropdown.Toggle className="dropdown-button" id="dropdown-page-size">
            {pageSize}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {pageSizeOptions.map((size) => (
              <Dropdown.Item
                key={size}
                active={pageSize.toString() === size.toString()} 
                onClick={() => handlePageSizeChange(parseInt(size, 10))}
              >
                {size}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default CustomPaginationComponent;